import * as React from 'react';
export const IcRepeatOne = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4 12a5 5 0 015-5h3.59l-.3.29a1 1 0 00.326 1.639 1 1 0 001.094-.22l2-2a1 1 0 00.21-.33 1 1 0 000-.76 1 1 0 00-.21-.33l-2-2a1.004 1.004 0 10-1.42 1.42l.3.29H9a7 7 0 00-7 7 6.94 6.94 0 002.59 5.43 1.001 1.001 0 101.26-1.55A5 5 0 014 12zm17.69-9a.48.48 0 00-.54.11l-1 1a.495.495 0 00.7.7l.15-.1V6.5a.5.5 0 001 0v-3a.5.5 0 00-.31-.5zm-2.28 3.57a.999.999 0 10-1.26 1.55A5 5 0 0115 17h-3.59l.3-.29a1.004 1.004 0 10-1.42-1.42l-2 2a1 1 0 00-.21.33 1 1 0 000 .76 1 1 0 00.21.33l2 2a.998.998 0 001.42 0 .997.997 0 00.219-1.095.998.998 0 00-.219-.325l-.3-.29H15a7 7 0 007-7 6.939 6.939 0 00-2.59-5.43z'
      fill='currentColor'
    />
  </svg>
);
